// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__fsAj_","title":"Images45_title__1j5kQ","images":"Images45_images__2BDw0"};